// The receipt chip on a Finance merchant line, from rows the page already has
// (Finance_Transactions.ReceiptRef). No extra call.
//
//   green chip   "Receipt · n of m": charges on the line holding a receipt
//   FIG marker   "no receipt · n": on a FIG line only, the charges without one,
//                unless the line's category is plainly not a purchase
//   nothing      any other line with no receipt

// Category names that are not purchases (no receipt to expect): transfers,
// payroll and wages, taxes, loan payments. Matched on the Finance_Categories
// name, whole words, any case. The spend list already leaves out the
// Movement and Assets & Savings groups before this is asked.
export const NON_PURCHASE_RE = /\b(transfers?|payroll|wages?|tax(es)?|loans?)\b/i;

const refOf = (tx) => (typeof tx?.ReceiptRef === 'string' && tx.ReceiptRef.trim() ? tx.ReceiptRef.trim() : null);

/** { withReceipt, total, refs } for the charges on one merchant line. */
export function receiptCountsForLine(txs) {
  const list = Array.isArray(txs) ? txs : [];
  const refs = [];
  let withReceipt = 0;
  for (const tx of list) {
    const r = refOf(tx);
    if (!r) continue;
    withReceipt++;
    if (!refs.includes(r)) refs.push(r);
  }
  return { withReceipt, total: list.length, refs };
}

/**
 * Charges on a FIG line with no receipt, or 0 when the marker should not
 * show (not FIG, or a non-purchase category).
 */
export function figNoReceiptCount(txs, categoryName) {
  if (NON_PURCHASE_RE.test(String(categoryName || ''))) return 0;
  return (Array.isArray(txs) ? txs : []).filter((tx) => tx?.Context === 'FIG' && !refOf(tx)).length;
}

/** The chip's words. */
export const chipText = ({ withReceipt, total }) => `${withReceipt === 1 && total === 1 ? 'Receipt' : 'Receipts'} · ${withReceipt} of ${total}`;
